// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Collapse, Row, Col } from 'react-bootstrap'; // eslint-disable-next-line
import wallet_pass from '../../../assets/img/logos/wallet_pass.png'; // eslint-disable-next-line
import { copy } from '../Common';
const LoginHistoryAccordianItem = ({ active, onToggle, currentIndex, pageLanguageContent, profileId, data, loginHistoryData }) => {
	
	function getLoginHistoryDate(dateString) {
		const date = new Date(dateString);
		const yyyyMmDd = date.toLocaleDateString('en-CA');
		return yyyyMmDd;
	}
	return (
		<Card className='shadow-none border rounded-0'>
			<CardHeader
				onClick={onToggle}
				className={`py-2 border-none cursor-pointer ${active ? 'activeMemebrShipHeader' : 'deActiveMemebrShipHeader'}`}
			>
				<span className='font-weight-medium text-dark text-sans-serif pl-2'>{pageLanguageContent['PRL167'] ? pageLanguageContent['PRL167'] : ''}</span>
				<div className='openHideAccordian'>
					<span className="updownArrow">
						{active ? <i className='fas fa-angle-up'></i> : <i className='fas fa-angle-down'></i>}
					</span>
				</div>
			</CardHeader>
			<Collapse in={active}>
				<CardBody className='pt-3'>
					{loginHistoryData && loginHistoryData.length > 0 &&
						loginHistoryData.map((item, i) => (
						<Row>
							<Col sm='12' className="p-1">
								<span>{getLoginHistoryDate(item?.created)}: </span>
								<span>{item?.info}</span>
							</Col>
						</Row>
					))}
				</CardBody>
			</Collapse>
		</Card>
	);
};
export default LoginHistoryAccordianItem;